import ChildrenBlock from '../ChildrenBlock';
import React from 'react';

export function Group({ tagName = 'div' }: { tagName: string }) {
    return React.createElement(tagName, {},
        <div className="wp-block-group__inner-container">
            <ChildrenBlock />
        </div>,
    );
}